import { QualifiedInvoiceIssueRequest } from "@graffer-inc/smart-apply";

type issueUIStateLiteral =
  | "HIDE_AREA"
  | "NO_REQUESTS"
  | "DISABLE_BUTTON"
  | "WITHDRAWN"
  | "CAN_ISSUE"
  | "SHOW_DETAIL"
  | "REVOKED";

export const calcIssueUIState = ({
  issueRequest,
  issueControlStatus,
}: {
  issueRequest:
    | {
        issuedCount: number;
        withdrewAt: QualifiedInvoiceIssueRequest["withdrewAt"];
        hasAvailable: boolean;
      }
    | undefined;
  issueControlStatus: {
    hasTaxablePayment: boolean;
    isIssuableProcedure: boolean;
    isPaymentCompleted: boolean;
    isIssuableApplicationStatus: boolean;
  };
}): issueUIStateLiteral => {
  // no request
  if (!issueRequest) {
    if (
      !issueControlStatus.isIssuableProcedure ||
      !issueControlStatus.hasTaxablePayment
    ) {
      return "HIDE_AREA";
    }
    return "NO_REQUESTS";
  }

  // has issue request and not issued
  if (issueRequest.issuedCount === 0) {
    if (issueRequest.withdrewAt) {
      return "WITHDRAWN";
    }
    if (
      !issueControlStatus.isIssuableProcedure ||
      !issueControlStatus.hasTaxablePayment ||
      !issueControlStatus.isPaymentCompleted ||
      !issueControlStatus.isIssuableApplicationStatus
    ) {
      return "DISABLE_BUTTON";
    }
    return "CAN_ISSUE";
  }

  // has request and already issued
  if (issueRequest.hasAvailable) {
    return "SHOW_DETAIL";
  }
  if (issueRequest.withdrewAt) {
    return "WITHDRAWN";
  }

  return "REVOKED";
};

export const cantIssueDescription = ({
  isIssuableProcedure,
  hasTaxablePayment,
  isPaymentCompleted,
  isIssuableApplicationStatus,
}: {
  isIssuableProcedure: boolean;
  hasTaxablePayment: boolean;
  isPaymentCompleted: boolean;
  isIssuableApplicationStatus: boolean;
}): string => {
  let description = "";

  if (!isIssuableProcedure) {
    description +=
      "\n・ 手続きに対して適格請求書発行事業者の紐付けがされていません(管理者にお問合せください)。\n";
  }
  if (!hasTaxablePayment) {
    description += "\n・ 課税対象の決済がありません。\n";
  }
  if (!isPaymentCompleted) {
    description += "\n・ 支払い依頼中の決済が完了していません。\n";
  }
  if (!isIssuableApplicationStatus) {
    description += "\n・ 申請ステータスが完了となっていません。\n";
  }

  description +=
    "\n※ こちらを解消した上で交付するか、交付の依頼を取り下げてください。\n";

  return description;
};

export const showDetailTitle = ({
  hasTaxablePayment,
  isPaymentCompleted,
}: {
  hasTaxablePayment: boolean;
  isPaymentCompleted: boolean;
}): string => {
  let title = "";

  if (!hasTaxablePayment) {
    title += "課税対象の決済がありません。";
    return title;
  }
  if (!isPaymentCompleted) {
    title += "支払い依頼中の決済があります。";
  }
  return title;
};

export const showDetailDescription = ({
  hasTaxablePayment,
  isPaymentCompleted,
}: {
  hasTaxablePayment: boolean;
  isPaymentCompleted: boolean;
}): string => {
  let description = "";

  if (!hasTaxablePayment) {
    description += "\n※ 交付した支払い明細書の取り消しをおこなってください。\n";
    return description;
  }
  if (!isPaymentCompleted) {
    description +=
      "\n※ 交付した支払い明細書を確認し、内容に変更がある場合は取り消しをおこなってください。\n";
  }
  return description;
};

export const issuedCount = ({
  available,
  revoked,
}: {
  available: QualifiedInvoiceIssueRequest["availableIssuedQualifiedInvoice"];
  revoked: QualifiedInvoiceIssueRequest["revokedQualifiedInvoices"];
}) => {
  return (available ? 1 : 0) + revoked.length;
};
